import 'metanav-ui_library_preact';
import { logout } from '../../actions/auth.actions';
import { MAIN_MENU_SETTINGS } from '../../constants/menu.constants';
import { DOSSIERS_PATH } from '../../constants/paths.constants';
import permissionsService from '../../services/permissions/permissions.service';
import Breadcrumbs from './Breadcrumbs';
import HeaderNotifications from './header-notifications/HeaderNotifications';

const SPOHeader = ({ user, authenticated }) => {
  window.spoLogin = () => (window.location = '/login');
  window.spoLogout = () => {
    logout();
  };
  const userForHeader = authenticated
    ? user.firstName || user.lastName
      ? JSON.stringify({ firstName: user.firstName, lastName: user.lastName, avatarUrl: user?.avatarUrl ?? '' })
      : JSON.stringify({ firstName: 'Onbekend', lastName: '' })
    : '';

  const getMenuItemLabel = (item) => {
    if (item.path === DOSSIERS_PATH && permissionsService.canSeeAllDossiers(user)) {
      return 'Dossiers';
    }

    return item.label;
  };

  const menuContent =
    authenticated && !user?.isFirstLogin && user?.permissions?.length > 0
      ? JSON.stringify([
          {
            items: MAIN_MENU_SETTINGS.map((x) => ({ label: getMenuItemLabel(x), href: x.path }))
          }
        ])
      : '';

  const logoLink = authenticated && user?.permissions?.length > 0 ? '/dossiers' : '/doe-je-aanvraag';
  return (
    <mtn-header
      menucontent={menuContent}
      logosmainlink={logoLink}
      webcomponent
      loginFunction="spoLogin"
      logoutFunction="spoLogout"
      profileUser={userForHeader}
    >
      <div>
        {authenticated && !!user && (user.firstName || user.lastName) && !user?.isFirstLogin && <HeaderNotifications />}
        <Breadcrumbs />
      </div>
    </mtn-header>
  );
};

export default SPOHeader;
